<template>
  <layout>
    <div v-if="type === 'xs'">
      <div class="flex flex-col h-[100dvh] landscape:h-screen bg-white">
        <div
          class="flex flex-col space-y-2 pb-4 pt-6 pl-4 text-xl font-medium text-gray-900 bg-white border-b"
        >
          <ArrowNarrowLeft
            class="w-6 text-gray-500 hover:text-gray-900 hover:cursor-pointer -ml-0.5"
            @click="handleBack"
          />
          <h1 class="font-semibold">{{ tenant.name }}</h1>
        </div>

        <div class="flex flex-col divide-gray-200 divide-y bg-white">
          <span
            @click="handleClicked(item)"
            v-for="item in settings.filter((s) => !s.hidden)"
            :key="item.name"
            class="flex items-center px-6 py-5 text-sm font-medium text-gray-900"
          >
            <component
              :is="item.icon"
              class="mr-3 flex-shrink-0 h-5 w-5 text-gray-900"
              aria-hidden="true"
            />
            <span class="truncate flex-1">{{ item.name }}</span>
            <ChevronRight class="w-10 text-gray-400 -mr-3" />
          </span>
        </div>
      </div>
    </div>
  </layout>
</template>

<script setup>
import { useBreakpoints } from "@/Tailwind/Mixins/useBreakpoints";
import { inject, onBeforeMount, unref } from "vue";
import { router } from "@inertiajs/vue3";
import { usePage } from "@inertiajs/vue3";
import route from "ziggy-js";
import TagOne from "@/Tailwind/Icon/TagOne.vue";
import UsersOne from "@/Tailwind/Icon/UsersOne.vue";
import MessageSmileCircle from "@/Tailwind/Icon/MessageSmileCircle.vue";
import ArrowNarrowLeft from "@/Tailwind/Icon/ArrowNarrowLeft.vue";
import ChevronRight from "@/Tailwind/Icon/ChevronRight.vue";
import { useI18n } from "vue-i18n";
import PersistentLayout from "@/Layouts/PersistentLayout.vue";
import ShieldTwo from "@/Tailwind/Icon/ShieldTwo";
import Information from "@/Tailwind/Icon/Information";
import Layout from "@/Tailwind/Pages/Settings";

defineOptions({ layout: PersistentLayout });

const { t } = useI18n();

const tenant = usePage().props.tenant;

const { type } = useBreakpoints();

const { hasPermission, permissions } = inject("permissions");

// @todo Not ideal, but works for now. Ensures this page is only usable on Mobile.
onBeforeMount(() => {
  if (unref(type) !== "xs") {
    router.visit(route("settings.location.index", [tenant]));
  }
});

const settings = [
  {
    name: t("admin.settings.location_settings.title"),
    icon: Information,
    href: route("settings.location.index", tenant),
    current: true,
  },
  {
    name: t("admin.settings.categories.title"),
    icon: TagOne,
    href: route("settings.categories.index", tenant),
    current: false,
    hidden: !hasPermission(permissions.readCategory),
  },
  {
    name: t("admin.settings.users.title"),
    icon: UsersOne,
    href: route("settings.users.index", tenant),
    current: false,
    hidden: !hasPermission(permissions.readUser),
  },
  {
    name: t("admin.settings.permissions.title"),
    icon: ShieldTwo,
    href: route("settings.roles.index", tenant),
    current: false,
    hidden: !hasPermission(permissions.readRole),
  },
  {
    name: t("admin.settings.messenger.title"),
    icon: MessageSmileCircle,
    href: route("settings.messenger.index", tenant),
    current: false,
    hidden: !hasPermission(permissions.readMessengerFlow),
  },
];

function handleClicked(item) {
  router.visit(item.href);
}

function handleBack() {
  router.visit(route("settings.organisation.buildings"));
}
</script>
